/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { SourceSpeakersOut } from './sourceSpeakersOut';

export interface SpeakersOut {
  sources: SourceSpeakersOut[];
  unassigned_count: number;
  write_back_blocked: boolean;
  block_reason: string | null;
}
